import { IMAGE_BASE } from './site';

export const PROJECTS = {
  'road-paint-repair': {
    title: 'Road Paint Repair',
    description: 'Revitalize roads with expert paint repair for a smooth, safe journey.',
    overview:
      'We restored lane markings and surface paint across major urban corridors in Vientiane, improving visibility for drivers and pedestrians alike. The work included full surface preparation, high-durability paint application, and post-installation quality checks.',
    scope: [
      'Road surface cleaning and preparation',
      'Lane marking and center-line repainting',
      'Crosswalk and safety zone restoration',
      'Final inspection and client handover',
    ],
    image: `${IMAGE_BASE}/img21.jpg`,
    timeline: '2 months',
    budget: '$50,000',
    client: 'City of Vientiane',
    location: 'Vientiane Capital',
  },
  'aluminum-signs': {
    title: 'Aluminum Signs',
    description:
      'Durable aluminum signs with weather-resistant finishes for long-lasting visibility.',
    overview:
      'A complete aluminum signage rollout for commercial and municipal clients. Signs were fabricated to spec, finished with weather-resistant coatings, and installed at high-traffic locations for maximum visibility.',
    scope: [
      'Custom aluminum panel fabrication',
      'Reflective and UV-resistant coating',
      'On-site mounting and alignment',
      'Maintenance guidelines provided',
    ],
    image: `${IMAGE_BASE}/img23.jpg`,
    timeline: '1 month',
    budget: '$20,000',
    client: 'ABC Corporation',
    location: 'Saysettha District',
  },
  'made-to-order-signs': {
    title: 'Made-to-Order Signs',
    description: 'Custom signage tailored to your specifications for a standout impact.',
    overview:
      'Bespoke signage designed and manufactured to exact client requirements — from concept sketches through production and installation. Each sign was built for brand impact and outdoor durability.',
    scope: [
      'Design consultation and mock-ups',
      'Custom fabrication to client dimensions',
      'Quality finishing and packaging',
      'Delivery and installation support',
    ],
    image: `${IMAGE_BASE}/img25.jpg`,
    timeline: '3 weeks',
    budget: '$10,000',
    client: 'XYZ Ltd.',
    location: 'Vientiane Capital',
  },
  'custom-signage': {
    title: 'Custom Signage',
    description: 'Design custom signage for businesses and institutions.',
    overview:
      'End-to-end custom signage for local businesses and institutions — combining design, material selection, and professional installation to create signage that stands out and lasts.',
    scope: [
      'Site survey and design proposal',
      'Material and finish selection',
      'Fabrication and quality control',
      'Professional on-site installation',
    ],
    image: `${IMAGE_BASE}/img26.jpg`,
    timeline: '4 weeks',
    budget: '$15,000',
    client: 'Local Business Partners',
    location: 'Vientiane Capital',
  },
  'traffic-signs': {
    title: 'Traffic Signs',
    description: 'Ensure road safety with quality traffic signs.',
    overview:
      'Supply and installation of regulatory and warning traffic signs along key routes. All signs meet international visibility standards and are built to withstand Laos weather conditions.',
    scope: [
      'Sign type planning and placement mapping',
      'Reflective sign manufacturing',
      'Post installation and height calibration',
      'Compliance verification',
    ],
    image: `${IMAGE_BASE}/img27.jpg`,
    timeline: '6 weeks',
    budget: '$35,000',
    client: 'Ministry of Public Works',
    location: 'National Route Network',
  },
  'outdoor-banners': {
    title: 'Outdoor Banners',
    description: 'High-quality banners for outdoor advertising.',
    overview:
      'Large-format outdoor banners produced with weather-resistant materials for retail and promotional campaigns. Includes design support, printing, and secure mounting hardware.',
    scope: [
      'Banner design and size optimization',
      'UV-resistant large-format printing',
      'Reinforced grommets and hem stitching',
      'Installation at designated locations',
    ],
    image: `${IMAGE_BASE}/img28.jpg`,
    timeline: '2 weeks',
    budget: '$8,000',
    client: 'Retail Partners',
    location: 'Vientiane Capital',
  },
  'digital-billboards': {
    title: 'Digital Billboards',
    description: 'Eye-catching digital billboards for enhanced visibility.',
    overview:
      'Design, supply, and installation of digital billboard systems for high-visibility advertising. Integrated LED panels with remote content management capability for the client media team.',
    scope: [
      'Structural assessment and site prep',
      'LED panel supply and wiring',
      'Control system setup and testing',
      'Operator training and warranty handover',
    ],
    image: `${IMAGE_BASE}/img29.jpg`,
    timeline: '2 months',
    budget: '$45,000',
    client: 'Media Group Laos',
    location: 'Major Intersection, Vientiane',
  },
  'construction-signs': {
    title: 'Construction Signs',
    description: 'Durable construction signs for safety and visibility.',
    overview:
      'Safety and directional signage for active construction zones — helping protect workers and guide traffic through temporary road layouts with clear, durable warning signs.',
    scope: [
      'Safety sign planning per site layout',
      'Heavy-duty sign fabrication',
      'Temporary mounting and repositioning',
      'Sign retrieval after project completion',
    ],
    image: `${IMAGE_BASE}/img30.jpg`,
    timeline: '3 weeks',
    budget: '$12,000',
    client: 'Construction Consortium',
    location: 'Infrastructure Project Site',
  },
};

export const PROJECT_LIST = Object.entries(PROJECTS).map(([slug, project], index) => ({
  id: index + 1,
  slug,
  title: project.title,
  description: project.description,
  img: project.image,
  url: `/project-detail/${slug}`,
}));

export const getRelatedProjects = (currentSlug, limit = 3) =>
  PROJECT_LIST.filter((p) => p.slug !== currentSlug).slice(0, limit);
